window.dropzonePreviewTemplate = '<div class="custom-upload__wrap"><div class="custom-upload__img"><img data-dz-thumbnail /></div><div class="custom-upload__icon"><svg class="icon icon--processing"><use xlink:href="#load"></use></svg><svg class="icon icon--success"><use xlink:href="#circle-small-included"></use></svg><svg class="icon icon--error"><use xlink:href="#warning"></use></svg></div><div class="custom-upload__filename" data-dz-name></div><div class="custom-upload__control"><svg class="icon icon--processing" data-dz-remove><use xlink:href="#close-circle-small"></use></svg><svg class="icon icon--success" data-dz-remove><use xlink:href="#trash-bin"></use></svg><svg class="icon icon--error" data-dz-remove><use xlink:href="#trash-bin"></use></svg></div><div class="custom-upload__progress"><span  data-dz-uploadprogress></span></div><div class="custom-upload__error" data-dz-errormessage></div></div>';

window.categoryColours = {
   "personal": '#1e8985',
   "lifestyle": '#d99938',
   "professional": '#523861',
   "tourism": '#98012e',
   "business": '#223A5E',
   "everything": '#fb7268',
   "central": '#0053c4',
   "personal_darker": '#155f5c',
   "lifestyle_darker": '#9e6b1e',
   "professional_darker": '#392743',
   "tourism_darker": '#690120',
   "business_darker": '#172841',
   "everything_darker": '#ef1606',
   "central_darker": '#003987'
};

function getCategoryColour(name) {
   return getComputedStyle(document.body).getPropertyValue(name).trim();
}
window.getCategoryColour = getCategoryColour;

$.widget("custom.iconselectmenu", $.ui.selectmenu, {

   _renderButtonItem: function (item) {
      var buttonItem = $("<span>", {
         "class": "ui-selectmenu-flag"
      });
      buttonItem.attr('style', item.element[0].dataset.style);

      return buttonItem;
   },

   _renderItem: function (ul, item) {
      var li = $("<li>"),
         wrapper = $("<div>", { text: item.label });

      if (item.disabled) {
         li.addClass("ui-state-disabled");
      }

      $("<span>", {
         style: item.element.attr("data-style"),
         class: "ui-icon "
      }).appendTo(wrapper);

      $('<span class="ui-helper-text"> ' + item.value + '</span>')
         .appendTo(wrapper);

      return li.append(wrapper).appendTo(ul);
   }
});

var preloadImg = function (imgArr) {
   $.each(imgArr, function (index, value) {
      $("<img/>")[0].src = value;
   });
}
window.preloadImg = preloadImg;



function initGetScrollBarWidth(){
   const body = document.querySelector("body");
   const scrollbar = window.innerWidth - body.clientWidth;
   body.setAttribute("style", `--scrollbar-width: ${scrollbar}px`);
}

function initNavPositioning() {

   var $navbar = $('.navbar');
   var navbarHeight = $navbar.outerHeight();
   var $quoteNav = $navbar.find('.navbar-quote');
   var quoteNavExists = $quoteNav.length ? true : false;

   if (quoteNavExists) {
      navbarHeight += $quoteNav.outerHeight();
   }

   var lastScrollPos = $(document).scrollTop();
   $(window).on('scroll', function () {
      var scrollPos = $(document).scrollTop();   

      if (scrollPos >= lastScrollPos) {
         if (scrollPos > navbarHeight) {
            $navbar.css('top', -navbarHeight);
         } else {
            $navbar.css('top', -scrollPos);
         }
         if (quoteNavExists) $('#chatTrigger').dropdown('hide');

      } else {
         $navbar.css('top', 0);
      }

      lastScrollPos = $(window).scrollTop();
   });

   $(window).on('resize orientationchange', function () {
      navbarHeight = $('.navbar').outerHeight();
      if (quoteNavExists) {
         navbarHeight += $quoteNav.outerHeight();
      }
   });

}
window.initNavPositioning = initNavPositioning;

function initPopoverCustomize() {

   var hoverOrFocus = matchMedia('(pointer:fine)').matches ? 'hover' : 'focus';

   // standard popover
   $('.popover-trigger--std[data-toggle="popover"]:not(.popover-trigger--close)').popover({
      template: '<div class="popover" role="tooltip"><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
      trigger: hoverOrFocus
   });

   // standard popover with close btn
   $('.popover-trigger--std.popover-trigger--close[data-toggle="popover"]').popover({
      template: '<div class="popover" role="tooltip"><h3 class="popover-header"></h3><div class="popover-body"></div><div class="popover-close"><img src="/assets/icn/close-medium.svg" class="icon" /></div></div>'
   });

   // wording popover
   $('.popover-trigger--wording[data-toggle="popover"]:not(.popover-trigger--close)').popover({
      template: '<div class="popover popover--wording" role="tooltip"><h3 class="popover-header"></h3><div class="popover-body"></div><div class="popover-close"><img src="/assets/icn/close-medium.svg" class="icon" /></div></div>',
      trigger: hoverOrFocus
   });

   // wording popover with close btn
   $('.popover-trigger--wording.popover-trigger--close[data-toggle="popover"]').popover({
      template: '<div class="popover popover--wording" role="tooltip"><h3 class="popover-header"></h3><div class="popover-body"></div><div class="popover-close"><img src="/assets/icn/close-medium.svg" class="icon" /></div></div>'
   });

   // small popover
   $('.popover-trigger--sm[data-toggle="popover"]:not(.popover-trigger--hover)').popover({
      template: '<div class="popover popover--sm" role="tooltip"><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
   });

   // small popover (hover on non-touch devices)
   $('.popover-trigger--sm.popover-trigger--hover[data-toggle="popover"]').popover({
      template: '<div class="popover popover--sm" role="tooltip"><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
      trigger: hoverOrFocus,
      boundary: hoverOrFocus === 'hover' ? 'window' : 'scrollParent'
   });


   // special pill hover effect
   $('.pill .popover-trigger')
      .on('shown.bs.popover', function () {
         $(this).closest('.pill').addClass('is-hover')
      })
      .on('hidden.bs.popover', function () {
         $(this).closest('.pill').removeClass('is-hover')
      });

   // prevent any controls from being activated when popover clicked
   $('.popover-trigger').on('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
   });

}
window.initPopoverCustomize = initPopoverCustomize;

function initCustomDropdowns() {

   // custom dropdown trigger
   $('[data-widget="CustomDropdown"]').each(function () {

      // ensure only init once
      if ($(this).data('init')) return;

      $(this).data('init', true);

      var $this = $(this);
      var $select = $this.find('select');

      $this
         .append('<div class="custom-dropdown__value">')
         .append('<div class="custom-dropdown__arrow"><svg class="icon"><use xlink:href="#dropdown-down-small">');

      var $val = $this.find('.custom-dropdown__value');

      // set label
      $val.text($select.find(':selected').text());

      // add init style
      if ($select.find(':selected').val() == '') {
         $val.addClass('custom-dropdown__value--init');
      }


      // on change, remove init style if has value
      $select.on('change', function () {
         $val.text($select.find(':selected').text());

         if ($select.find(':selected').val() !== '') {
            $val.removeClass('custom-dropdown__value--init');
         } else {
            $val.addClass('custom-dropdown__value--init');
         }

      });




   });

   // jquery ui selectmenu init
   var selectMenuOpen = false;
   $('.ui-selectmenu:not(.ui-selectmenu--country)').selectmenu({
      icons: { button: "" },
      position: {
         my: "left top",
         at: "left bottom",
         collision: 'flip'
      },

      // special case: if a selectmenu dropdown is open when persistant dropdown is open, don't allow close
      open: function (event, ui) {
         selectMenuOpen = true
      },
      close: function (event, ui) {
         // insert delay as the dropdown hide function kicks in immediately after the selectmenu has closed
         setTimeout(function () {
            selectMenuOpen = false;
         }, 100);
      }
   });

   $('.dropdown--persist').on('hide.bs.dropdown', function (e) {
      return !selectMenuOpen;
   });


   // placeholder styling
   $('.ui-selectmenu').each(function () {
      var $select = $(this);

      if ($select.find(':selected').val() == '') {
         $select.addClass('is-placeholder');
      }

      $select.on('selectmenuchange', function () {
         if ($select.find(':selected').val() !== '') {
            $select.removeClass('is-placeholder');
         } else {
            $select.addClass('is-placeholder');
         }
      });

   });

   // country selectmenu init
   $(".ui-selectmenu--country")
      .iconselectmenu({
         icons: { button: "" },
         position: {
            my: "left top",
            at: "left bottom",
            collision: 'flip'
         }
      })
      .iconselectmenu("menuWidget")
      .addClass("ui-menu-icons ui-menu--country");

}
window.initCustomDropdowns = initCustomDropdowns;


function initCartDropdown() {
   $('#cart-dropdown')
      .on('show.bs.dropdown', function () {
         $('body').append('<div class="cart-summary__backdrop"></div>');
      })
      .on('hidden.bs.dropdown', function () {
         $('.cart-summary__backdrop').remove();
      });
}

function initQuoteProgress() {
   $(document).on('click', '#quote-progress-trigger, #quote-progress-trigger-desktop', function (e) {      
      e.preventDefault();
      
      const $trigger = $(this);
      const $bothTriggers = $('#quote-progress-trigger, #quote-progress-trigger-desktop');
      const $tar = $($trigger.attr('href'));
      const $slide = $tar.find('.quote-progress__slide');

      if($trigger.hasClass('is-active')) { 
         $bothTriggers.removeClass('is-active');
         $tar.removeClass('quote-progress-active').addClass('quote-progress-inactive');
      } else {   
         $bothTriggers.addClass('is-active');
         $tar.addClass('quote-progress-active').removeClass('quote-progress-inactive');
      }      

      // if desktop version and open by default, don't add outside click handler
      if( $trigger.attr('id') === 'quote-progress-trigger-desktop' && $tar.hasClass('quote-progress-load') ) {         
         return;   
      }     
    
      $(document)
         .off('click.handlequoteoutside')
         .on('click.handlequoteoutside', handleOutsideClick);      

      function handleOutsideClick(e) {         
         if (!$slide[0].contains(e.target) && $slide.has(e.target).length === 0 && !$trigger[0].contains(e.target)) {      
            $bothTriggers.removeClass('is-active');
            $tar.removeClass('quote-progress-active').addClass('quote-progress-inactive');
            $(document).off('click.handlequoteoutside');                
         }
      }

   });

}
window.initQuoteProgress = initQuoteProgress;


function initMegaDropdown() {
   $('.navbar-actions__dropdown')
      .on('show.bs.dropdown', function () {
         $('body').append('<div class="dropdown__backdrop"></div>');
      })
      .on('hidden.bs.dropdown', function () {
         $('.dropdown__backdrop').remove();
      });
}


function initPersistantDropdowns() {
   // $('.dropdown--persist .dropdown-toggle').on('click', function (event) {
   //    $(this).parent().toggleClass('show')
   //       .find('.dropdown-menu').toggleClass('show');
   // });   

   // $('body').on('click', function (e) {
   //    if (!$('.dropdown--persist').is(e.target) 
   //        && $('.dropdown--persist').has(e.target).length === 0 
   //        && $('.show').has(e.target).length === 0
   //    ) {
   //       $('.dropdown--persist').removeClass('show')
   //          .find('.dropdown-menu').removeClass('show');
   //    }
   // });  



   $(document).on('click', '.dropdown--persist .dropdown-menu', function (e) {
      if (!$(e.target).closest('.dropdown-close').length) {
         e.stopPropagation();
      }
   });


}

function initSeeMore() {
   $('.seemore__expander').each(function () {

      // init only once
      if (!$(this).data('init')) {
         $(this).data('init', true);

         $(this)
            .on('show.bs.collapse', function (e) {
               var seeMoreId = $(e.target).attr('id');
               var $btnTrigger = $('.seemore[data-target="#' + seeMoreId + '"]');
               $btnTrigger.find('strong').html($btnTrigger.attr('data-text-expanded'));
               if ($btnTrigger.attr('data-text-expanded') === undefined) {
                  $btnTrigger.hide();
               }
            })
            .on('hide.bs.collapse', function (e) {
               var seeMoreId = $(e.target).attr('id')
               var $btnTrigger = $('.seemore[data-target="#' + seeMoreId + '"]');
               $btnTrigger.find('strong').html($btnTrigger.attr('data-text-collapsed'));
            });

      }

   });
}
window.initSeeMore = initSeeMore;

function initAccordionPositioning() {

   // scroll open accordion item into view on mobile only
   if ($(window).width() < 768) {

      $('.card-body.collapse[data-parent]').on('show.bs.collapse', function (e) {
         var $card = $(this).closest('.card, .accordion__item');
         var $open = $($(this).data('parent')).find('.collapse.show');

         var additionalOffset;
         var navbarHeight = $('.navbar').outerHeight();
         navbarHeight += $('.navbar-quote').outerHeight();

         if ($card.prevAll().filter($open.closest('.card, .accordion__item')).length !== 0) {
            additionalOffset = $open.height();
         }

         $('html,body').animate({
            scrollTop: $card.offset().top - additionalOffset - navbarHeight - 20
         }, 500);

      });


      // scroll mobile summary active item into view
      $('.modal-summary__content .collapse').on('shown.bs.collapse', function (e) {

         var $item =
            $(this).prev('.quote-summary-item__subtitle').length ?
               $(this).prev('.quote-summary-item__subtitle') : $(this).closest('.quote-summary-item');

         var scrollableTop = $('.modal-summary__content').offset().top;
         var scrollableOffset = $('.modal-summary__content').scrollTop();

         $('.modal-summary__content').animate({
            scrollTop: $item.offset().top + scrollableOffset - scrollableTop
         }, 500);

      });


   }
}


// function initCustomToggle() {

//    // custom toggle trigger
//    $('[data-widget="CustomToggle"]').each(function () {

//       // ensure only init once
//       if (!$(this).data('init')) {
//          $(this).data('init', true);

//          var $this = $(this);
//          var $input = $this.find('input');
//          var $inputText = $this.find('.custom-toggle__indi > span');

//          // init text
//          if ($input.prop('checked')) {
//             $inputText.text('Yes');
//          } else {
//             $inputText.text('No');
//          }

//          // on change, update text
//          $input.change(function () {
//             if ($input.prop('checked')) {
//                $inputText.text('Yes');
//             } else {
//                $inputText.text('No');
//             }
//          });

//       }

//    });


// }


function initFormControlClear() {
   $(document).on('click', '.form-control__clear', function (e) {
      e.preventDefault();
      var $input = $(this).closest('.form-group, .form-control__wrap').find('.form-control');
      $input.val('').trigger('change');
   });
}


function initMultiSelectLogic() {

   $(document).on('change', '.custom-input--checkbox input[data-type="exclusive"]', function (e) {
      var $exclusiveCtrl = $(this);

      var $siblingCtrls = $exclusiveCtrl
         .closest('.custom-input--checkbox')
         .siblings('.custom-input--checkbox')
         .find('input[type="checkbox"]');

      if ($exclusiveCtrl.is(":checked")) {
         $siblingCtrls
            .prop('disabled', true)
            .prop('checked', false)
            .closest('.custom-input--checkbox').removeClass('is-mod');
      } else {
         $siblingCtrls.prop('disabled', false);
      }

   });

}

var customStep = (function () {

   var $el,
      $input,
      min,
      max,
      $controlDsc,
      $controlAsc
   self = this;

   function init(el, callback) {

      $el = el;
      $input = $el.find('.form-control');
      min = parseInt($el.find('.form-control').attr('data-min'));
      max = parseInt($el.find('.form-control').attr('data-max'));
      $controlDsc = $el.find('.custom-step__control--dsc');
      $controlAsc = $el.find('.custom-step__control--asc');

      sanitize();

      $controlDsc.on('click', function () {
         var curVal = getVal();
         if (!$controlDsc.hasClass('custom-step__control--disabled')) {
            $input.val(curVal -= 1).trigger('change');
            callback('dsc', curVal);
         }
      });
      $controlAsc.on('click', function () {
         var curVal = getVal();
         if (!$controlAsc.hasClass('custom-step__control--disabled')) {
            $input.val(curVal += 1).trigger('change');
            callback('asc', curVal);
         }
      });

      $input.on('change', function () {
         sanitize();
      });

   }




   function sanitize() {
      var val = $input.val();

      // if NaN, reset to min value
      if (isNaN(val)) {
         $input.val(min);
      }

      updateControlState();
   }

   function updateControlState() {
      var val = getVal();
      if (val <= min) {
         $controlDsc.addClass('custom-step__control--disabled');
         $input.val(min);
      } else {
         $controlDsc.removeClass('custom-step__control--disabled');
      }

      if (val >= max) {
         $controlAsc.addClass('custom-step__control--disabled');
         $input.val(max);
      } else {
         $controlAsc.removeClass('custom-step__control--disabled');
      }
   }

   function updateRange(minVal, maxVal) {
      min = minVal;
      max = maxVal;
      sanitize();
   }

   function updateVal(val) {
      $input.val(val).trigger('change');
   }

   function disable() {
      $input.prop('disabled', true);
      $controlDsc.addClass('custom-step__control--disabled');
      $controlAsc.addClass('custom-step__control--disabled');
   }

   function enable() {
      $input.prop('disabled', false);
      updateControlState();
   }

   function getVal() {
      return parseInt($input.val());
   }


   return {
      init: init,
      updateVal: updateVal,
      updateRange: updateRange,
      getVal: getVal,
      disable: disable,
      enable: enable
   }

});
window.customStep = customStep; // make globally accessible

// var customModal = (function () {
//    var $el;

//    function init() {

//       // listen for open
//       $(document).on('click', '[data-toggle="custom-modal"]', function (e) {    
//          e.preventDefault();
//          var el = $(this).attr('data-target') || $(this).attr('href');
//          $el = $(el);
//          show();
//       });

//       // listen for close
//       $(document).on('click', '[data-dismiss="custom-modal"]', function (e) {
//          e.preventDefault();
//          dismiss();
//       });
//    }

//    function show() {
//       $('body').addClass('modal-open');
//       $el.addClass('in');

//       // for transitions
//       setTimeout(function () {
//          $el.addClass('show');
//       }, 1);      
//       setTimeout(function () {
//          $el.removeClass('in');
//       }, 400);
//    }

//    function dismiss() {
//       $('.custom-modal').removeClass('show');      
//       setTimeout(function () {
//          $('body').removeClass('modal-open');
//       }, 400);      
//    }

//    return {
//       init: init
//    }
// })();
// window.customModal = customModal; // make globally accessible

function initReadMore() {

   $('[data-widget="ReadMore"]').each(function () {

      // ensure only init once
      if ($(this).data('init')) return;
      $(this).data('init', true);


      var $this = $(this);

      // only work with the first p tags' contents if it exists
      var containsHTML = $this.find('p:first').length ? true : false;
      var $text = containsHTML ? $text = $this.find('p:first') : $this;

      var SPLIT_LENGTH = $text.data('splitlength') || 25; // default
      var TEXT_MORE = $text.data('more-text') || 'Read more';
      var TEXT_LESS = $text.data('less-text') || 'Read less';

      var splitWords = $text.html().split(/[\s]+/);

      // split only if text long enough to split
      if (splitWords.length > SPLIT_LENGTH) {

         var generatedHTML = '<span class="readmore__short">' + splitWords.slice(0, SPLIT_LENGTH).join(' ') + '</span>';
         generatedHTML += '<span class="readmore__long"> ' + splitWords.slice(SPLIT_LENGTH).join(' ') + '</span>';
         generatedHTML += '<span class="readmore__dots">&hellip;</span> <strong class="readmore__btn">' + TEXT_MORE + '</strong>';


         $text.html(generatedHTML);

         // show/hide on read more/less click
         $this.on('click', '.readmore__btn', function (e) {
            e.preventDefault();
            var $btn = $(this);
            if (!$this.hasClass('is-active')) {
               $this.addClass('is-active');
               if (containsHTML) $btn.appendTo($this);
               $btn.text(TEXT_LESS);
            } else {
               $this.removeClass('is-active');
               if (containsHTML) $btn.appendTo($text);
               $btn.text(TEXT_MORE);
            }
         });

      }




   });

}
window.initReadMore = initReadMore; // make globally accessible


function scrollTo($el, duration, offset, callback) {
   if ($el.length) {

      var duration = typeof duration !== 'undefined' ? duration : 500;
      var offset = typeof offset !== 'undefined' ? offset : 0;

      $('html, body').animate({
         scrollTop: $el.offset().top - $('.navbar').outerHeight() - offset
      }, duration).promise().then(function () {
         if (callback) callback();
      });

   }
}
window.scrollTo = scrollTo;


// function initHelpModalProducts() {

//    var $helpModal = $('#help-modal');

//    function showProduct($tar, showBack) {

//       if (showBack == null) showBack = false;

//       // hide categories
//       $helpModal.find('.modal-help__categories').removeClass('is-active');

//       // show product
//       $helpModal.find('.modal-help__products').addClass('is-active');
//       if (showBack) $helpModal.find('.modal-help__back').addClass('is-active');
//       $tar.addClass('is-active');

//       $helpModal.find('.modal-help__content').scrollTop(0);
//    }

//    function hideProducts() {
//       // show categories
//       $helpModal.find('.modal-help__categories').addClass('is-active');

//       // hide products
//       $helpModal.find('.modal-help__products').removeClass('is-active')
//          .find('.everything-products').removeClass('is-active');
//       $helpModal.find('.modal-help__back').removeClass('is-active');

//       $helpModal.find('.modal-help__content').scrollTop(0);
//    }


//    $helpModal.on('hidden.bs.modal', function (e) {
//       if ($helpModal.find('.everything-categories').length) hideProducts();
//    });

//    $helpModal.find('.modal-help__back').on('click', function (e) {
//       e.preventDefault();
//       hideProducts();
//    });

//    // activate deeper product categories
//    $(document).on('click', '[data-product=external]', function (e) {
//       e.preventDefault();
//       var $this = $(this);
//       $tar = $($this.attr('href'));
//       $helpModal.modal('show');

//       showProduct($tar, $this.closest('.modal-help').length);

//       // close mobile menu if open
//       $('#mobile-quote-menu').modal('hide');
//    });

// }

function initAcquisitionNav() {
   // load product content
   $(document).on('click', '.product-nav__nav li a', function (e) {
      e.preventDefault();
      let target = $(this).attr('href');

      // remove default selected class on any category click
      $('.product-nav__nav li').removeClass('is-default');

      // mark active nav item
      // $(this).closest('li').addClass('is-active')
      //    .siblings('li').removeClass('is-active');

      $('.product-nav__nav li a[href="' + target + '"]').closest('li').addClass('is-active')
         .siblings('li').removeClass('is-active');

      // show content on desktop
      $(target).addClass('is-active')
         .siblings().removeClass('is-active');

      // load content on mobile         
      $('#mobile-navbar-content').html($(target).html());

      // update mobile modal title      
      $('#product-nav-modal-mobile-title').html($(this).find('.img-fluid').clone());

      // slide in content on mobile
      $('#product-nav-modal-mobile').addClass('is-active');

   });

   // mobile: load learn nav content
   $(document).on('click', '#learn-nav-trigger', function (e) {
      e.preventDefault();
      let target = $(this).attr('href');

      // load content on mobile  
      $('#mobile-navbar-content').html($(target).html());

      // slide in content on mobile
      $('#product-nav-modal-mobile').addClass('is-active');
   });

   // mobile close button
   $('#mobile-quote-menu').on('show.bs.modal', function (e) {
      // reset mobile modal title
      $('#product-nav-modal-mobile-title').html('&nbsp;');
   });

   // mobile back button
   $(document).on('click', '#mobile-quote-menu .modal-traymenu__header-back', function (e) {
      e.preventDefault();
      // slide out content on mobile
      $('#product-nav-modal-mobile').removeClass('is-active');

      // update mobile modal title
      $('#product-nav-modal-mobile-title').html('&nbsp;');

      // scroll to top of div  
      $('.modal-traymenu__content').scrollTop(0);
   });

   // mobile close button
   $('#mobile-quote-menu').on('hidden.bs.modal', function (e) {

      // slide out content on mobile
      $('#product-nav-modal-mobile').removeClass('is-active');

      // update mobile modal title
      $('#product-nav-modal-mobile-title').html('&nbsp;');
   });

}
window.initAcquisitionNav = initAcquisitionNav;

function initProductsModal() {
   // special handling for modal version of product nav
   let originalModalTitle = 'Our products';

   // load active content on modal show
   $('#product-nav-modal').on('show.bs.modal', function (e) {

      originalModalTitle = $('#product-nav-modal-title').text();

      // add dark overlay
      $('body').addClass('modal-open--dark');

      // if data-toggle-category is specified, trigger that category
      let category = $(e.relatedTarget).data('toggle-category');
      if (category) {
         $('#product-nav-modal').find('.product-nav__nav li a[href="#help-category-' + category + '"]')
            .trigger('click');
      }

      // load content on desktop modal version     
      let target = $('#product-nav-modal').find('.product-nav__nav li.is-active a').attr('href') ||
         $('#product-nav-modal').find('.product-nav__nav li.is-default a').attr('href');
      $('#product-nav-modal-content').html($(target).html());

   });


   $('#product-nav-modal').on('click', '.product-nav__nav li a', function (e) {
      e.preventDefault();
      let target = $(this).attr('href');

      // load content on desktop modal version     
      $('#product-nav-modal-content').html($(target).html());

      // update mobile modal title      
      $('#product-nav-modal-title').html($(this).find('.img-fluid').clone());

      // show product content & enable mobile back button
      $('#product-nav-modal').addClass('is-active');

   });

   // mobile back button
   $(document).on('click', '#product-nav-modal .modal-categories__back', function (e) {
      e.preventDefault();

      // slide out content on mobile
      $('#product-nav-modal').removeClass('is-active');
      $('#product-nav-modal-mobile').removeClass('is-active');

      // update mobile modal title
      $('#product-nav-modal-title').text(originalModalTitle);

      // scroll to top of div      
      $('.modal-traymenu__content').scrollTop(0);

   });

   // mobile close button
   $('#product-nav-modal').on('hidden.bs.modal', function (e) {
      // slide out content on mobile
      $('#product-nav-modal').removeClass('is-active');
      $('#product-nav-modal-mobile').removeClass('is-active');

      // update mobile modal title
      $('#product-nav-modal-title').text(originalModalTitle);

      // undo dark bg
      $('body').removeClass('modal-open--dark');
   });
}
window.initProductsModal = initProductsModal;

function initQuoteBtn() {

   function scrollQuoteBtnCheck() {

      let scroll_pos = window.pageYOffset;

      if (scroll_pos > trigger_pos) {
         $navBtn.addClass("is-active");
         $navbar.addClass("quote-btn-active");
      } else {
         $navBtn.removeClass("is-active");
         $navbar.removeClass("quote-btn-active");
      }
   }

   let $navbar = $(".navbar");
   let $navBtn = $(".navbar-actions__quote-btn");

   if (!$navBtn.length) return;

   let trigger_pos = $("#hero-quote-btn").length ? $("#hero-quote-btn").offset().top : 450; // fallback to 500px   

   scrollQuoteBtnCheck();
   $(window).on("scroll", scrollQuoteBtnCheck);
}

function initModalHandler() {


   // if after closing a modal, other modals are still open, add modal-open back
   $('[data-dismiss="modal"]').off('click').on('click', function (e) {

      $('.modal.show')
         .on('hidden.bs.modal', function (e) {

            if ($('.modal.show').length) {
               $('body').addClass('modal-open');

               console.log('add modal-open');
            }
         });
   });


   $('[data-toggle="modal"]').off('click').on('click', function (e) {
      var $btn = $(this);

      if ($btn.attr('href') !== 'javascript:;' && $btn.attr('href') !== "#") {

         var tar = $btn.attr('href') || $btn.attr('data-target');
         var $tar = $(tar);

         // modal switcher - first close existing modal before opening next
         if ($btn.attr('data-dismiss') === 'modal' || $btn.hasClass('modal-traymenu__list-item')) {

            $('.modal.show:not(.modal--persist)')
               .modal('hide')
               .on('hidden.bs.modal', function (e) {
                  if ($btn.attr('data-modal-type') === 'static' || $tar.hasClass('modal--note')) {
                     $tar.modal({
                        show: false,
                        keyboard: false,
                        backdrop: 'static'
                     });
                  }
                  $tar.modal('show');
                  console.log('showing new modal')
                  $(this).off('hidden.bs.modal');
               });

            // stop bootstrap from launching modal prematurely (we're launching modal manually)    
            return false;


            // 'static' modals (don't close on outside click)
         } else if ($btn.attr('data-modal-type') === 'static' || $tar.hasClass('modal--note')) {
            $tar.modal({
               keyboard: false,
               backdrop: 'static'
            });

            // tooltips triggered from same element as modals persist after opening/closing modals
            // force close
         } else if ($btn.attr('data-tooltip') === "tooltip") {

            $tar
               .on('show.bs.modal', function () {
                  $btn.tooltip('hide');
               })
               .on('hidden.bs.modal', function () {
                  setTimeout(function () {
                     $btn.tooltip('hide');
                  }, 10);
               });
         }

      }


   });
}
window.initModalHandler = initModalHandler;

var customAnswer = (function () {
   var
      $controlGroup,
      percentTotal = 100;

   var currencyFormat = wNumb({
      prefix: "R ",
      thousand: " ",
      decimals: 0,
   });

   function init(el, callback) {
      $controlGroup = el;

      // default override
      percentTotal = typeof $controlGroup.data('percent') !== 'undefined' ?
         parseInt($controlGroup.data('percent')) : percentTotal;

      _handleInput();
      _handleRemove();
      _handleSelect();
      _handleSliderChange();

      // if control linked to 'add' button
      if ($controlGroup.data('linked-add')) {
         _handleAdd($('#' + $controlGroup.data('linked-add')));
      }


      function _handleInput() {
         $controlGroup.find('.custom-answer').each(function () {

            var $controlInput = $(this).find('.custom-answer__percent input, .custom-answer__amount input');

            $controlInput
               // .on('input', function (e) {
               //    // format as currency if placeholder begins with 'R'            
               //    if ($(this).attr('placeholder').charAt(0) === 'R') {
               //       var value = currencyFormat.from($(this).val());
               //       var valueFormatted = currencyFormat.to(value);
               //       $(this).val(valueFormatted);
               //    }
               // })
               .on('keypress', function (e) {
                  // allow only numbers
                  return (e.charCode != 8 && e.charCode == 0 || (e.charCode >= 48 && e.charCode <= 57));
               })
               .on('input', function (e) {
                  _total({ type: 'default', valueElement: $(this) });
               });
         })
      }

      function _handleAdd($btn) {
         $btn.on('click', function (e) {
            e.preventDefault();
            _add();
         });
      }

      function _handleRemove() {
         $controlGroup.find('.action-remove').on('click', function (e) {
            e.preventDefault();
            _remove($(this));
         })
      }

      function _handleSelect() {
         $controlGroup.find('.custom-input--answer input').on('change', function () {

            var $slider = $(this).closest('.custom-answer').find('.custom-answer__slider');
            var $sliderInput = $slider.find('.custom-rangeslider__input input');
            var $amountEl = $(this).closest('.custom-answer').find('.custom-answer__amount p');

            if ($(this).is(':checked')) {
               $slider.addClass('is-active');
               $amountEl.removeClass('is-inactive');

               var inputValueFormatted = $sliderInput.val();
               _updateSliderAmountAndTotal($amountEl, inputValueFormatted);

            } else {
               $slider.removeClass('is-active');
               $amountEl.addClass('is-inactive');
               _updateSliderAmountAndTotal($amountEl, 'R 0');
            }

         });
      }

      function _handleSliderChange() {
         $controlGroup.find('.custom-answer__slider input')
            .on('change', function (e) {
               var inputValueFormatted = $(this).val();
               _updateSliderAmountAndTotal($(this).closest('.custom-answer').find('.custom-answer__amount p'), inputValueFormatted);
            });
      }


      function _updateSliderAmountAndTotal($amountEl, value) {
         $amountEl.find('[data-amount]').text(value);
         _total({ type: 'slider', valueElement: $amountEl.find('[data-amount]') });
      }


      function _total(params) {

         var $totalEl = $controlGroup.parent('.question-panel').find('span[data-total]');
         var totalAmount = 0;

         if (params.type === 'default') {
            totalAmount = currencyFormat.from(params.valueElement.val()) || 0;
            params.valueElement.closest('.custom-answer').siblings().find('.custom-answer__percent, .custom-answer__amount').each(function () {
               totalAmount += currencyFormat.from($(this).find('input').val()) || 0;
            });
         } else if (params.type === 'slider') {
            totalAmount = currencyFormat.from(params.valueElement.text()) || 0;
            params.valueElement.closest('.custom-answer').siblings().find('.custom-answer__amount').each(function () {
               totalAmount += currencyFormat.from($(this).find('[data-amount]').text()) || 0;
            });
         }


         $totalEl.text(totalAmount);

         _validate($totalEl, totalAmount);

      }

      function _validate($totalEl, totalAmount) {

         // only validate percentage-based controls
         if ($controlGroup.hasClass('custom-answer__group--percent')) {
            if (totalAmount > percentTotal) {
               $totalEl.addClass('is-invalid');
               if (callback) callback({ 'state': 'invalid', 'total': totalAmount });
            } else {
               $totalEl.removeClass('is-invalid');
               if (callback) callback({ 'state': 'valid', 'total': totalAmount });
            }
         } else {
            if (callback) callback({ 'state': 'no validation', 'total': totalAmount });
         }

      }


      function _add() {
         var $clone = $controlGroup.find('.custom-answer:first').clone();
         $clone.find('input').val('');
         $controlGroup.append($clone);

         // re-run handleInput & handleRemove with updated $controlGroup
         _handleInput();
         _handleRemove();
      }

      function _remove($btn) {
         $btn.closest('.custom-answer').remove();

         // re-run handleInput with updated $controlGroup
         _handleInput();

         // recalculate totals
         _total({ type: 'default', valueElement: $controlGroup.find('.custom-answer:first .custom-answer__percent input, .custom-answer:first .custom-answer__amount input') });

      }

   }

   return {
      init: init
   }
});
window.customAnswer = customAnswer; // make globally accessible


function initCustomAmount(control) {

   const currencyFormat = wNumb({
      thousand: " ",
      decimals: 2,
   });

   const amountItems = control.querySelectorAll('.custom-amount');

   // init total
   total(amountItems);

   // add event listener to each input
   amountItems.forEach(function (amount) {
      amount.querySelector('.custom-amount__input input').addEventListener('input', function (e) {
         total(amountItems);
      });
   });


   function total(items) {
      let totalAmount = 0;
      items.forEach(function (item) {
         totalAmount += currencyFormat.from(item.querySelector('.custom-amount__input input').value) || 0;
      });

      let totalElement = control.querySelector('.custom-amount__total-amount span[data-total]');
      if (totalElement) totalElement.textContent = currencyFormat.to(totalAmount);
   }


}
window.initCustomAmount = initCustomAmount; // make globally accessible

var notify = (function () {

   var settings = {
      message: '',
      icon: null,
      link: null,
      size: null,
      style: null,
      close: false,
      autoClose: true,
      speed: 350,
      duration: 5000,
      static: null,
      onClosed: null
   }

   var $el,
      elId,
      closeTimeout = null;

   function init(args, id) {

      elId = typeof id !== 'undefined' ? id : 0;

      var called = false;
      $('.notify').each(function () {
         if (parseInt($(this).attr('data-id')) === elId) called = true;
      });

      if (!called) {

         settings.message = args.message;
         settings.icon = args.icon || settings.icon;
         settings.link = args.link || settings.link;

         settings.size = args.size || settings.size;
         settings.style = args.style || settings.style;
         settings.close = typeof args.close !== 'undefined' ? args.close : settings.close;
         settings.autoClose = typeof args.autoClose !== 'undefined' ? args.autoClose : settings.autoClose;
         settings.speed = args.speed || settings.speed;
         settings.duration = args.duration || settings.duration;
         settings.static = args.static || settings.static;
         settings.onClosed = args.onClosed || settings.onClosed;

         render();
      }


   }

   function render() {

      var styleClass = settings.style ? 'notify--' + settings.style : '';
      var sizeClass = settings.size ? 'notify--' + settings.size : '';
      var staticClass = settings.static ? 'notify--static' : '';

      var notifyHTML = '<div data-id="' + elId + '" class="notify notify--simple ' + styleClass + ' ' + sizeClass + ' ' + staticClass + '">';
      notifyHTML += '<div class="notify__content">';
      if (settings.icon) notifyHTML += '<svg class="icon"><use xlink:href="#' + settings.icon + '"></use></svg>';
      notifyHTML += '<p>' + settings.message + '</p>';
      if (settings.link) notifyHTML += '<div class="notify__content-link">' + settings.link + '</div>';
      if (settings.close) notifyHTML += '<svg class="icon icon--close"><use xlink:href="#close-circle-small"></use></svg>';
      notifyHTML += '</div>';
      notifyHTML += '</div>';

      if (settings.static) {
         $(settings.static).append(notifyHTML);
      } else {
         $('body').append(notifyHTML);
      }


      // $el = $('.notify[data-id='+elId+']');
      $el = $('.notify.notify--simple');

      $el
         .hide()
         .fadeIn(settings.speed, function () {

            if (settings.close) {
               $el.find('.icon--close').on('click', clear);
            }

            if (settings.autoClose && settings.duration !== 'indefinite') {
               closeTimeout = setTimeout(clear, settings.duration);
            }


         });

   }


   function clear() {
      clearTimeout(closeTimeout);
      $el.fadeOut(settings.speed, function () {
         $el.remove();
         if (settings.onClosed) settings.onClosed();
      });
   }


   return {
      init: init,
      clear: clear
   }
});
window.notify = notify; // make globally accessible

var copyToClipboard = function (el) {
   var copyText = document.getElementById(el);
   copyText.select();
   copyText.setSelectionRange(0, 99999); /* For mobile devices */
   document.execCommand('copy');

   var copyToClipboardNotify = new notify();
   copyToClipboardNotify.init({
      message: "Successfully copied!",
      icon: 'complete',
      size: 'lg',
      style: 'positive',
      close: false,
      duration: 3000,
   }, 2000);

};

function fallbackCopyTextToClipboard(text, textMsg) {
   var textArea = document.createElement("textarea");
   textArea.value = text;

   // Avoid scrolling to bottom
   textArea.style.top = "0";
   textArea.style.left = "0";
   textArea.style.position = "fixed";

   document.body.appendChild(textArea);
   textArea.focus();
   textArea.select();

   try {
      var successful = document.execCommand('copy');
      if (successful) {
         var copyTextToClipboardNotify = new notify();
         copyTextToClipboardNotify.init({
            message: textMsg,
            icon: 'complete',
            size: 'lg',
            style: 'positive',
            close: false,
            duration: 3000,
         }, 2000);
      } else {
         console.log('Fallback: Copying text command was unsuccessful');
      }

   } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
   }

   document.body.removeChild(textArea);
}

function copyTextToClipboard(text, $el) {

   let textMsg = 'Successfully copied!';
   if ($el.attr('data-copy-text-msg')) textMsg = $el.attr('data-copy-text-msg');

   if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text, textMsg);
      return;
   }

   navigator.clipboard.writeText(text).then(function () {
      var copyTextToClipboardNotify = new notify();
      copyTextToClipboardNotify.init({
         message: textMsg,
         icon: 'complete',
         size: 'lg',
         style: 'positive',
         close: false,
         duration: 3000,
      }, 2000);


   }, function (err) {
      console.error('Async: Could not copy text: ', err);
   });
}


function isElementInViewport(el, partiallyVisible = false) {

   // default to fully visible check
   // partiallyVisible = typeof partiallyVisible !== 'undefined' ? partiallyVisible : false;

   // Special bonus for those using jQuery
   if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
   }

   const { top, left, bottom, right } = el.getBoundingClientRect();
   const { innerHeight, innerWidth } = window;
   return partiallyVisible
      ? ((top > 0 && top < innerHeight) ||
         (bottom > 0 && bottom < innerHeight)) &&
      ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
      : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
};

window.isElementInViewport = isElementInViewport;


var matchHeights = (function () {
   var settings;

   function init(args) {
      settings = args;

      // get unique groups
      var mhGroups = [];
      $("[data-mh]").each(function () {
         var item = $(this).attr("data-mh");
         if (mhGroups.indexOf(item) === -1) {
            mhGroups.push(item);
         }
      });

      // loop through groups
      mhGroups.forEach(function (el, idx) {
         setMaxHeight(mhGroups[idx]);
      });
   }

   function getTallest(group) {
      var height = 0;
      $("[data-mh='" + group + "']").each(function () {
         height = $(this).height() > height ? $(this).height() : height;
      });
      return height;
   }

   function setMaxHeight(group) {
      if ($(window).width() >= settings.breakpoint) $("[data-mh='" + group + "']").height(getTallest(group));

      $(window).on("resize", function () {
         $("[data-mh='" + group + "']").removeAttr("style");
         if ($(window).width() >= settings.breakpoint) $("[data-mh='" + group + "']").height(getTallest(group));
      });
   }

   return {
      init: init,
   };
})();
window.matchHeights = matchHeights; // make globally accessible

function initChatDropdown() {

   $(document).on('shown.bs.dropdown', '#chatDropdown, #chatDropdown-modal', function () {
      if ($(window).width() < 768) {
         $('body').addClass('modal-open');
         $('body').append('<div class="chat-info__backdrop"></div>');
      }
   }).on('hidden.bs.dropdown', '#chatDropdown, #chatDropdown-modal', function () {
      $('body').removeClass('modal-open');
      $('.chat-info__backdrop').remove();
   });

   // special case for when chat trigger is inside action sheet menu
   $(document).on('click', '#chatActionTrigger', function (e) {
      e.preventDefault();
      $('#nav-action-sheet').on('hidden.bs.modal', function () {
         $('#chatTrigger').click();
         $('#nav-action-sheet').off('hidden.bs.modal');
      }).modal('hide');
   });

}



function initSummaryFeed() {
   $(document).on('click', '#summary-feed-close', function (e) {
      e.preventDefault();
      var $tar = $($(this).attr('href'));
      $tar.removeClass('policy-feed-active');
   });

   // on summary item click, open feed and scroll to note
   $(document).on('click', '[data-trigger="summary-feed"]', function (e) {
      e.preventDefault();

      var targetId = $(this).attr('href').substring(1);
      var $tar = $('[data-id="' + targetId + '"]');
      if (!$tar.length) return;

      // open feed and scroll to note
      var isDesktop = window.matchMedia('(min-width: 992px)').matches;
      if (isDesktop) {
         if ($('#page-canvas').hasClass('policy-feed-active')) {
            policyFeedScrollToSelected($tar);
         } else {
            $('#page-canvas').addClass('policy-feed-active');
            setTimeout(function () {
               policyFeedScrollToSelected($tar);
            }, 500);
         }
      } else {
         $('#modal-summary-feed').modal('show');
         setTimeout(function () {
            policyFeedScrollToSelected($tar);
         }, 500);
      }


   });
}


function initTooltips() {
   // enable tooltips
   $(':not(.icon-hover--flush, .icon-hover--slim)[data-tooltip="tooltip"]').tooltip({
      trigger: 'hover'
   });

   // clear tooltip on click
   $(document).on('click', '[data-tooltip="tooltip"]', function () {
      $(this).tooltip('hide');
   });

   $('.icon-hover--flush[data-tooltip="tooltip"]').tooltip({
      template: '<div class="tooltip tooltip--flush" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
   });

   $('.icon-hover--slim[data-tooltip="tooltip"]').tooltip({
      template: '<div class="tooltip tooltip--slim" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
   });


   $('[data-tooltip]').on('show.bs.tooltip', function () {
      var $trigger = $(this);

      $trigger.hasClass('is-active') ?
         $trigger.attr('data-original-title', $trigger.attr('data-title-active')) : $trigger.attr('data-original-title', $trigger.attr('data-title-closed'));

   });


}
window.initTooltips = initTooltips;

function initScrollTo() {
   $(document).on('click', '[data-scrollto]', function (e) {
      e.preventDefault();
      var tar = $(this).attr('href') || $(this).attr('data-scrollto');
      if (tar == null || tar === 'false') return;

      var offset = $(this).attr('data-scrollto-offset') != null ? parseInt($(this).attr('data-scrollto-offset')) : 0;
      var speed = $(this).attr('data-scrollto-speed') != null ? parseInt($(this).attr('data-scrollto-speed')) : 500;

      $('html,body').animate({
         scrollTop: $(tar).offset().top - $('.navbar').outerHeight() - offset
      }, speed);
   });
}




function initGotoURL(url) {
   $(document).on('click', '[data-goto-url]', function (e) {
      e.preventDefault();
      e.stopPropagation();
      location.href = $(this).attr('data-goto-url');
   });
}
window.initGotoURL = initGotoURL;


function debounce(func, timeout = 300){
   let timer;
   return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
   };
}
window.debounce = debounce;


function initAOS() {
   AOS.init({
      disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
      startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
      initClassName: 'aos-init', // class applied after initialization
      animatedClassName: 'aos-animate', // class applied on animation
      useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
      disableMutationObserver: false, // disables automatic mutations' detections (advanced)
      debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
      throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      offset: 120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 600, // values from 0 to 3000, with step 50ms
      easing: 'ease-out-quad', // default easing for AOS animations
      once: true, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
   });

   // refresh AOS animation script with each image load
   document.addEventListener('lazyloaded', function (e) {
      window.addEventListener('load', AOS.refresh());
   });
}
window.initAOS = initAOS;

function initCustomDialogs() {

   // attach custom dialog-open event to all dialogs
   const dialogOpenedEvent = new CustomEvent('dialog-open')
      , dialogOpenedObserver = new MutationObserver(mutations => {
         mutations.forEach((node) => {
            if (node.attributeName === 'open' && node.target.open) {
               node.target.dispatchEvent(dialogOpenedEvent);
            }
         })
      });

   // observe all <dialog> elements for open attribute changes
   document.querySelectorAll('dialog').forEach(dial => {
      dialogOpenedObserver.observe(dial, { attributes: true });
   });


   // detect new <dialog> elements inserted into the DOM via MutationObserver
   const dialogAddedObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
         if (mutation.addedNodes) {
            mutation.addedNodes.forEach((node) => {
               if (node.tagName === 'DIALOG') {
                  // observe newly inserted <dialog> elements for open attribute changes
                  dialogOpenedObserver.observe(node, { attributes: true });
               }
            });
         }
      });
   });

   // observe the entire document for new nodes being added
   dialogAddedObserver.observe(document.body, {
      childList: true,
      subtree: true
   });


   _handleDialogTrigger = (e) => {
      e.preventDefault();
      const dialogTrigger = e.currentTarget;
      const dialogId = dialogTrigger.getAttribute('href');
      const dialog = document.querySelector(dialogId);
      if (dialog) {
         dialog.showModal();
      }
   }

   _handleDialogCloseButtons = (e) => {
      e.preventDefault();
      const dialogCloseTrigger = e.currentTarget;
      const dialog = dialogCloseTrigger.closest('dialog');
      if (dialog) {
         dialog.close();
      }
   }



   // attach dialog triggers
   $(document).on('click', '[data-toggle="dialog"]', _handleDialogTrigger);


   // attach dialog close button triggers
   $(document).on('click', '[data-dismiss="dialog"]', _handleDialogCloseButtons);

}



const draggableSlider = (elem, callback) => {

   let mouseDown = false;
   let startX, scrollLeft;
   const slider = elem;

   const startDragging = (e) => {
      mouseDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
   }

   const stopDragging = (e) => {
      mouseDown = false;
   }

   const move = (e) => {
      e.preventDefault();
      if (callback) callback(mouseDown);

      // not dragging
      if (!mouseDown) { return; }
      const x = e.pageX - slider.offsetLeft;
      const scroll = x - startX;
      slider.scrollLeft = scrollLeft - scroll;
   }

   // Add the event listeners
   slider.addEventListener('mousemove', move, false);
   slider.addEventListener('mousedown', startDragging, false);
   slider.addEventListener('mouseup', stopDragging, false);
   slider.addEventListener('mouseleave', stopDragging, false);

};
window.draggableSlider = draggableSlider; // make globally accessible




var editModalGuides = function () {
   
   var IS_MOBILE = $(window).width() < 768 ? true : false;

   // UPDATED: 2023-10-12-commercial-flow
   function init(modalId, idx, mobileAsDesktop = false) {
      

      // MOBILE GUIDES
      if (IS_MOBILE && !mobileAsDesktop) { 
         
         // open modal if modal id is provided
         if(modalId) {
            // only open after modal open
            $(modalId).on('show.bs.modal', function (e) {                        
                 $('#mobile-guide-'+idx+'-modal').modal('show');
                 $('#mobile-guide-'+idx+'-tip-1').addClass('is-active');               
             });

            // remove all open guides if any on modal close
            $(modalId).on('hidden.bs.modal', function (e) {   
               $('.mobile-guide').removeClass('is-active');
               $('#mobile-guide-'+idx+'-modal').modal('hide');
             });
         } 

         if(!modalId){
            $("#mobile-guide-" + idx + "-modal").modal("show");
            $("#mobile-guide-" + idx + "-tip-1").addClass("is-active"); 
         }
                

         $(document).on("click", ".mobile-guide .button[data-guide-btn]", function (e) {
            e.preventDefault();

            // close current guide item
            var $btn = $(this);
            $btn.closest(".mobile-guide").removeClass("is-active");

            // go to next guide
            if ($btn.data("guide-btn") === "next") {
               var $nextGuide = $($btn.attr("href"));
               $nextGuide.addClass("is-active");
            } else if ($btn.data("guide-btn") === "end") {              
               $("#mobile-guide-" + idx + "-modal").modal("hide");
            }
         });

         // on guide 'close' btn click
         $(document).on("click", ".mobile-guide__close", function (e) {
            var $btn = $(this);
            $btn.closest(".mobile-guide").removeClass("is-active");
            $("#mobile-guide-" + idx + "-modal").modal("hide");
         });

         // NON-MOBILE GUIDES
      } else {

         // open modal if modal id is provided
         if(modalId) {
            // activate 1st guide after modal opens
            $(modalId).on('shown.bs.modal', function (e) {            
               setTimeout(function(){              
                  $('#guide-'+idx+'-tip-1').addClass('is-active');              
               }, 500);
            });

            // remove all open guides if any on modal close
            $(modalId).on('hidden.bs.modal', function (e) {   
               $('.guide').removeClass('is-active')
            });
         }

         // activate 1st guide after delay     
         if(!modalId) {    
            setTimeout(function () {                
               activateGuide( $("#guide-" + idx + "-tip-1"))
            }, 500);
         }
       

         var SCROLL_OFFSET = 150;
         var SCROLL_SPEED = 500;

         // on guide 'next' click
         $(document).on("click", ".guide .button[data-guide-btn]", function (e) {
            e.preventDefault();

            // close current guide item
            var $btn = $(this);
            $btn.closest(".guide").removeClass("is-active");
            var $pageScroll = $("html, body");

            // go to next guide
            // UPDATED: 2023-10-12-commercial-flow
            if ($btn.data("guide-btn") === "next") {
               var $nextGuide = $($btn.attr("href"));

               // if $nextGuide is fully in viewport, don't scroll, just activate
               if (isElementInViewport($nextGuide, false)) {
                  activateGuide($nextGuide);
                  return;
               }

               var scrollToPos = $nextGuide.offset().top - SCROLL_OFFSET;

               // if we got far to scroll, increase scroll duration
               var SCROLL_DURATION = scrollToPos - $pageScroll.scrollTop() > 1500 ? SCROLL_SPEED * 2 : SCROLL_SPEED;

               // animate to next guide
               $pageScroll.animate({ scrollTop: scrollToPos }, SCROLL_DURATION, function () {
                  activateGuide($nextGuide);
               });


            } 
         });

         // on guide 'close' btn click
         $(document).on("click", ".guide__close", function (e) {
            var $btn = $(this);
            $btn.closest(".guide").removeClass("is-active");
         });
      }
   }

   function activateGuide($guide) {      

      // if target exists, attach guide to target
      if($guide.data("target")) {            
         attachGuide($guide);

         // on resize, debounce and re-attach guide
         $(window).on("resize", debounce(function () {
            attachGuide($guide);
         }, 150));

      }

      $guide.addClass("is-active");

   }

   function attachGuide($guide) {
      var target = $guide.data("target");

      if (!target) return;

      var $target = $(target);

      var targetOffset = $target.offset();
      var targetWidth = $target.outerWidth();
      var targetHeight = $target.outerHeight();

      var guideOffset = $guide.offset();
      var guideWidth = $guide.outerWidth();
      var guideHeight = $guide.outerHeight();


      if ($guide.hasClass("guide--attached-top-center")) {
         // vertical top align
         var guideTop = targetOffset.top + targetHeight + 10;

         // horizontal centering
         var guideLeft = targetOffset.left + targetWidth / 2;
      }
   
      else if ($guide.hasClass("guide--attached-top-right")) {
         // vertical top align
         var guideTop = targetOffset.top + targetHeight + 10;

         // horizontal right align
         var guideLeft = targetOffset.left + targetWidth - guideWidth / 2;
      }

      else if ($guide.hasClass("guide--attached-btm-center")) {
         // vertical btm align
         var guideTop = targetOffset.top - guideHeight - 10;

         // horizontal centering
         var guideLeft = targetOffset.left + targetWidth / 2;
      }         

      $guide.css({
         top: guideTop,
         left: guideLeft,
      });
   }

   function close(){
      // close all guides
      $(".guide").removeClass("is-active");
      $(".mobile-guide").removeClass("is-active");      
   }

   return {
      init: init,
      close: close
   };
};

window.editModalGuides = editModalGuides; // make globally accessible


$(function () {

   $.fn.hasScrollBar = function () {
      return this.get(0).scrollHeight > this.innerHeight();
   }

   initGetScrollBarWidth();

   initAOS();

   initChatDropdown();

   /* popover customization */
   initPopoverCustomize();

   /* mobile nav shown on upwards scroll */
   initNavPositioning();

   /* don't remove dropdown on inside click */
   initPersistantDropdowns();

   /* init custom select elements on ready & on modal shown */
   initCustomDropdowns();
   $('.modal').on('shown.bs.modal', function (e) {
      initCustomDropdowns();
   });

   //initCartDropdown();
   initQuoteProgress();
   initMegaDropdown();

   /* see more expand/collapser */
   initSeeMore();


   /* slide active accordion item into view on mobile */
   initAccordionPositioning();


   /* init custom select elements on ready & on modal shown *
   initCustomToggle();
   $('.modal').on('shown.bs.modal', function (e) {                  
      initCustomToggle();
   });
   /* */


   initFormControlClear();

   /* multiple select with exclusive option */
   initMultiSelectLogic();

   initReadMore();

   // initHelpModalProducts();
   initAcquisitionNav();
   initProductsModal();

   initQuoteBtn();

   initModalHandler();

   $(document).on('click', 'a[data-copy]', function (e) {
      e.preventDefault();
      copyToClipboard($(this).attr('data-copy'));
   });

   $(document).on('click', 'a[data-copy-text]', function (e) {
      e.preventDefault();
      copyTextToClipboard($(this).attr('data-copy-text'), $(this));
   });


   initTooltips();
   initScrollTo();

   initSummaryFeed();

   initGotoURL();

   initCustomDialogs();

});